import * as types from './types';

export default {
    [types.SET_RESERVATIONS](state, reservations) {
        state.reservations = reservations;
    },
};